import styled from "styled-components"

export const BackgroundContainer = styled.div`background-color:${props=>props.isDark?"rgb(14, 13, 13)":"white"};`